export const useRequestUtils = () => {
  const getStatusBadgeColors = (status: string) => {
    switch (status) {
      case 'PENDING':
        return { backgroundColor: '#fef3c7', textColor: '#92400e' };
      case 'IN_PROGRESS':
        return { backgroundColor: '#dbeafe', textColor: '#1e40af' };
      case 'ACCEPTED':
        return { backgroundColor: '#d1fae5', textColor: '#065f46' };
      case 'REJECTED':
        return { backgroundColor: '#fee2e2', textColor: '#991b1b' };
      default:
        return { backgroundColor: '#fef3c7', textColor: '#92400e' };
    }
  };

  const getStatusLabel = (status: string) => {
    switch (status) {
      case 'PENDING':
        return 'Pendiente';
      case 'IN_PROGRESS':
        return 'En progreso';
      case 'ACCEPTED':
        return 'Aceptado';
      case 'REJECTED':
        return 'Rechazado';
      default:
        return status;
    }
  };

  return { getStatusBadgeColors, getStatusLabel };
}; 